import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { GrnItem } from '@shared/model/grn-item';


@Injectable({
  providedIn: 'root'
})
export class GrnService {
  
  
  
  constructor(private http: HttpClient) { }


  addGrnDirect(supplierId:any):Observable<any>{
    return this.http.post<any>(`${environment.serviceApi}/grns/direct/${supplierId}`,null);
  }
  addGrnforPo(purchaseOrderId:any):Observable<any>{
    return this.http.post<any>(`${environment.serviceApi}/grns/forpo/${purchaseOrderId}`,null);
  }
  getGrns(start:number,count:number):Observable<any[]>{
    return this.http.get<any[]>(`${environment.serviceApi}/grns?skip=${start}&count=${count}`);
  }

  getGrn(grnId: string): Observable<any> {
    return this.http.get<any>(`${environment.serviceApi}/grns/${grnId}`);
  }
  addNewGrnItem(id: any, grnItem: GrnItem):Observable<GrnItem> {
    return this.http.post<any>(`${environment.serviceApi}/grns/${id}/item`,grnItem);;
  }
  updateItem(grnItem: GrnItem) {
    return this.http.put<any>(`${environment.serviceApi}/grns/item`,grnItem);
  }
  completeGrn(id: any) {
    return this.http.put<any>(`${environment.serviceApi}/grns/${id}/complete`,null);
  }
  
  getStats(from: Date, to: Date): Observable<any> {
    const fromIso = from.toISOString();
    const toIso = to.toISOString();
    return this.http.get<any>(`${environment.serviceApi}/grns/stats?from=${fromIso}&to=${toIso}`);
  }
}
